query ConfigShow($id: ID!) {
  config(id: $id) {
    id
    key
    value
    createdAt
    updatedAt
    deletedAt
    deleted
  }
}
